import * as Types from './types';
import { actionTypes } from './constants';
import { IMaintenanceDataResponse } from '../types';

export const setMaintenanceDataAction = (data: IMaintenanceDataResponse): Types.ISetMaintenanceDataAction => ({
    type: actionTypes.MAINTENANCE_MODE_DATA_UPDATE,
    payload: data
});

export const setIsLoadingAction = (isLoading: boolean): Types.ISetIsLoadingAction => ({
    type: actionTypes.MAINTENANCE_MODE_IS_LOADING_UPDATE,
    payload: isLoading
});

export const setIsIntegrationScriptFailedAction = (isFailed: boolean): Types.ISetIsIntegrationScriptFailedAction => ({
    type: actionTypes.MAINTENANCE_MODE_IS_INTEGRATION_SCRIPT_FAILED_UPDATE,
    payload: isFailed
});
